import { Checkbox as UiCheckbox } from '@unlimitai/ui';
import classNames from 'classnames';
import type { InputHTMLAttributes, Ref } from 'react';
import { forwardRef } from 'react';

import styles from './index.module.scss';

export type Props = {
  readonly size?: 'small' | 'default';
} & Omit<InputHTMLAttributes<HTMLInputElement>, 'type' | 'size'>;

const Checkbox = ({ disabled, size = 'default', ...rest }: Props, ref: Ref<HTMLInputElement>) => {
  return (
    <div className={styles.checkbox}>
      <input type="checkbox" disabled={disabled} {...rest} ref={ref} readOnly />
      {/* The native input owns interaction. Radix's form proxy must not re-toggle the parent. */}
      <span
        aria-hidden="true"
        onClickCapture={(event) => {
          event.stopPropagation();
        }}
      >
        <UiCheckbox
          checked={rest.checked ?? false}
          disabled={disabled}
          tabIndex={-1}
          aria-hidden="true"
          className={classNames(styles.icon, size === 'small' && styles.small)}
        />
      </span>
    </div>
  );
};

export default forwardRef<HTMLInputElement, Props>(Checkbox);
